import React from 'react';
import * as PropTypes from 'prop-types';
import {Button} from 'reactstrap';

export const FormActionButtons = ({reset, submit}) => {

    const resetBtn = {
        ...FormActionButtons.defaultProps.reset,
        ...reset,
    };

    const submitBtn = {
        ...FormActionButtons.defaultProps.submit,
        ...submit,
    };

    /* eslint-disable-next-line react/no-multi-comp */
    const renderButton = (opts, label) => {
        const props = {
            outline: opts.outline,
            color: opts.color,
            disabled: opts.disabled,
            type: opts.type,
        };

        if (opts.handler !== null) {
            props.onClick = opts.handler;
        }

        return (<Button {...props}>{label}</Button>);
    };

    return (
        <div className="text-right">
            {resetBtn.show && (
                <span className="d-inline-block mr-1">
                    {
                        renderButton(
                            resetBtn,
                            'Reset Form'
                        )
                    }
                </span>
            )}
            {submitBtn.show && (
                <span className="d-inline-block">
                    {
                        renderButton(
                            submitBtn,
                            'Save'
                        )
                    }
                </span>
            )}
        </div>
    );
};

FormActionButtons.defaultProps = {
    reset: {
        color: 'secondary',
        disabled: false,
        handler: null,
        outline: true,
        show: true,
        type: 'reset',
    },
    submit: {
        color: 'primary',
        disabled: false,
        handler: null,
        outline: false,
        show: true,
        type: 'submit',
    },
};

const buttonShape = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    handler: PropTypes.func,
    outline: PropTypes.bool,
    show: PropTypes.bool,
    type: PropTypes.string,
};

FormActionButtons.propTypes = {
    reset: PropTypes.shape(buttonShape),
    submit: PropTypes.shape(buttonShape),
};

export default FormActionButtons;
